module.exports = __webpack_public_path__ + "img/bennett-logo.1a84b89f.jpg";